import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "besidaMob-cross.icon",
  "use": "besidaMob-cross.icon-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"besidaMob-cross.icon\"><path d=\"M12.707.707a1.001 1.001 0 0 0-1.42.006l-4.58 4.58-4.58-4.58A1.002 1.002 0 0 0 .708.707c-.39.39-.392 1.022.007 1.42l4.579 4.58-4.58 4.58a1.002 1.002 0 0 0-.006 1.42 1 1 0 0 0 1.42-.007l4.58-4.579 4.58 4.58a1 1 0 0 0 1.415-1.414L8.12 6.706l4.58-4.58c.394-.393.4-1.027.006-1.42z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol